import NavMenu from "../../common/NavMenu.js";

export default (el, i) => {
  const globalHeader = document.querySelector(".js-global-header");

  const onClose = () => {
    // check for quick search input
    if (el.querySelector("input")) {
      el.querySelector("input").value = "";
    }
    globalHeader.classList.remove("menu-is-open");
  };

  const onOpen = () => {
    globalHeader.classList.add("menu-is-open");
  };

  NavMenu({
    animationDelay: 800,
    closed: true,
    direction: "vertical",
    menuButton: ".js-nav-toggle",
    menuContainer: ".js-mobile-menu-content",
    navigationLink:
      ".js-primary-nav-top-link, .js-primary-nav-menu-button, input, button",
    openClass: "is-open",
    onClose: onClose,
    onOpen: onOpen,
    parent: el,
  });

  el.classList.add("menu-initialized");
};
